import { Injectable } from '@angular/core';
import { ClipboardObject } from '../model/clipboard/clipboardObject';
import { EntityInterface } from '../model/entity/interfaces/entityInterface.model';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {

  constructor() {
  }

  public copy(entityName: string, entities: Array<EntityInterface>): void {
    const clipboardObject = new ClipboardObject();
    clipboardObject.entities = entities;
    clipboardObject.type = entityName;
    const entitiesText = JSON.stringify(clipboardObject);
    localStorage.setItem('appClipboard', entitiesText);
    console.log('Copy data to aplication clipboard: ' + entitiesText);
  }
  public paste(): ClipboardObject {
    const objectText = localStorage.getItem('appClipboard');
    if (objectText && objectText !== '') {
      console.log('Paste data from aplication clipboard: ' + objectText);
      const object: ClipboardObject = JSON.parse(objectText);
      return object;
    }
    return null;
  }

}
